import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { TaskRestoreRegistration } from 'containers/forms/tasks'
// import { FilterRemovedRegistrations } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Button, BadgesLevels } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import { apiTasksRegistrationParticipants } from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Tasks - Registration',
  intlKey: 'pageTitle.tasks_removed_registration',
  dynamicProp: 'organizations.detail.name'
})
@apiTasksRegistrationParticipants({
  removed: true
})
@connect(null, { modal })
class TasksRemovedRegistrationParticipants extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onRestoreParticipantRegistration: PropTypes.func
    // disablePersistedFilter: PropTypes.bool
  }

  state = {
    participantId: null,
    registrationId: null
  }

  handleRestoreRegistration = (participantId, registrationId) => {
    this.setState(
      {
        participantId,
        registrationId
      },
      () => {
        this.props.modal('modal-restore')
      }
    )
  }

  // API is not ready for filtering and sorting

  render() {
    const {
      tasks: {
        removedRegistrations: { loading, list, offset, limit, pages, sort }
      }
      // setRemovedRegistrationTasksParams
      // disablePersistedFilter
    } = this.props

    return (
      <div>
        {/* <FilterRemovedRegistrations
          disablePersistedFilter={disablePersistedFilter}
        /> */}
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.removedRegistrationTableHeaders}
          // setParams={setRemovedRegistrationTasksParams}
        >
          <Data>
            {list.map(({
              id,
              creationDate,
              awardLevel,
              firstName,
              lastName,
              email,
              organizationName,
              award
            }) => (
              <tr key={id}>
                <td>{firstName}</td>
                <td>{lastName}</td>
                <td>{email}</td>
                <td>
                  {creationDate && <FormattedDate value={creationDate} />}
                </td>
                <td>
                  <BadgesLevels
                    levels={[
                      {
                        awardLevel
                      }
                    ]}
                    single
                  />
                </td>
                <td>{organizationName || '---'}</td>

                <td>
                  <Button
                    onClick={() =>
                      this.handleRestoreRegistration(
                        get(award, 'participant.id'),
                        id
                      )}
                    tiny
                  >
                    <FormattedMessage
                      id="button.restore"
                      defaultMessage="Restore"
                    />
                  </Button>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-restore" customActions>
          <TaskRestoreRegistration
            participantId={this.state.participantId}
            registrationId={this.state.registrationId}
            onSubmit={this.props.onRestoreParticipantRegistration}
          />
        </Modal>
      </div>
    )
  }
}

export default TasksRemovedRegistrationParticipants
